import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const SAMPLE_KEY = "afa_sample_chat";

export const useStart = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  return (sample) => {
    if (sample) sessionStorage.setItem(SAMPLE_KEY, JSON.stringify(sample.messages));
    navigate(user ? "/app" : "/login");
  };
};
